import React from 'react';
import { FeMap } from '../../components/map/fe-map';
import { WorkspaceItemContextObject } from './workspace-item-context';

export interface WorkspaceManagementContext {
    readonly items: WorkspaceItemContextObject[];
    readonly setMap: (map: FeMap | null, workspaceId: number) => unknown;
}

export const WorkspaceManagementContext = React.createContext<WorkspaceManagementContext>({
    items: [],
    setMap: () => {}
});
